import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import type { _PersistConfig } from "redux-persist/lib/types";

import { healthCheckReducer } from "../services/apollo/healthCheckReducer";
import { authReducer } from "../services/authentication/authReducer";
import { filterReducer } from "../services/booking-filter/filterReducer";
import { columnsFilterReducer } from "../services/columns-filter/columnsFilterReducer";
import { cookieConsentReducer } from "../services/cookie-consent/slice";
import { createReducer } from "../services/create/createReducer";
import { customsLinkLoaderReducer } from "../services/customs-link/customsLinkReducer";
import { dashboardReducer } from "../services/dashboard/dashboardReducer";
import { frontendOutOfDateReducer } from "../services/frontend-out-of-date/frontendOutOfDateReducer";
import { gridReducer } from "../services/grid/gridReducer";
import { createIntermodalBookingReducer } from "../services/intermodal/createIntermodalReducer";
import { intermodalGridStatusReducer } from "../services/intermodal/IntermodalGridStatusReducer";
import { updateIntermodalBookingReducer } from "../services/intermodal/updateIntermodalReducer";
import { modalReducer } from "../services/modal/modalReducer";
import { multiCreateReducer } from "../services/multi-create/multiCreateReducer";
import {
  type NotificationsReducerState,
  notificationsReducer,
} from "../services/notifications/notificationsReducer";
import { searchReducer } from "../services/search/searchReducer";
import { settingsReducer } from "../services/settings/settingsReducer";
import {
  type SidebarReducerState,
  sidebarReducer,
} from "../services/sidebar/sidebarReducer";
import { sortingReducer } from "../services/sorting/sortingReducer";
import { switchReducer } from "../services/switch/switchReducer";
import { tourReducer } from "../services/tour/tourReducer";
import { updateFormReducer } from "../services/update-form/updateFormReducer";
import { subscriptionSettingsReducer } from "../services/user-subscriptions/userSubscriptionsReducer";

const notificationsPersistConfig: _PersistConfig<NotificationsReducerState> = {
  storage,
  stateReconciler: false,
  key: "notifications-persisted-state",
};

const sidebarPersistConfig: _PersistConfig<SidebarReducerState> = {
  storage,
  stateReconciler: false,
  whitelist: ["railEnabled"],
  key: "sidebar-persisted-state",
};

export const rootReducer = combineReducers({
  auth: authReducer,
  columnsFilter: columnsFilterReducer,
  cookieConsent: cookieConsentReducer,
  customsLinkLoader: customsLinkLoaderReducer,
  create: createReducer,
  dashboard: dashboardReducer,
  filter: filterReducer,
  sidebar: persistReducer(
    sidebarPersistConfig,
    sidebarReducer,
  ) as typeof sidebarReducer,
  frontendOutOfDate: frontendOutOfDateReducer,
  grid: gridReducer,
  health: healthCheckReducer,
  intermodalCreate: createIntermodalBookingReducer,
  intermodalUiStatus: intermodalGridStatusReducer,
  intermodalUpdate: updateIntermodalBookingReducer,
  modal: modalReducer,
  multiCreate: multiCreateReducer,
  notifications: persistReducer(
    notificationsPersistConfig,
    notificationsReducer,
  ) as typeof notificationsReducer,
  searchQuery: searchReducer,
  settings: settingsReducer,
  sorting: sortingReducer,
  switch: switchReducer,
  tour: tourReducer,
  updateForm: updateFormReducer,
  userSubscriptions: subscriptionSettingsReducer,
});
